import React, { useEffect, useRef, useState } from "react";
import SlideUpWrapper from "../../../../components/Transitions/SlideUpWrapper";
import style from "../../../DashBoard/CompanyProfile.module.css";
import templateStyles from "../../../DashBoard/Templates/Templates.module.css";
import API from "../../../../ApiConfig";
import {
  ATTRATION_INSIGHTS,
  BASE_URL,
  GET_ALL_COMPANIES,
  USER_TOKEN,
} from "../../../../Utils/constant";

import dropdownStyle from "../../../DashBoard/ExternalDash/Verifier/VerifyUsers.module.css";

import CustomDropDown from "../../../../components/CustomDropDown";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import IssuerNavigator from "../../../../components/DashBoard/IssuerNavigator";
import CompanyInsightCharts from "../../CompanyInsightCharts";
import ShimmerLoader from "../../../../components/ShimmerLoader";
import TopTitleBar from "../TopTitleBar";
import { useSelector } from "react-redux";
import { buildInsightsReportNode } from "./insightsReportTemplate";
const RecordInsights = () => {
  // useRefreshToken(BASE_URL + USER_TOKEN)
  const [loading, setLoading] = useState(false);
  const [downloading, setDownloading] = useState(false);
  const User=useSelector(state=>state.User)

  console.log(User);
  
  const [GraphType, setGraphType] = useState("Pie Chart");
  const No_of_Days = [
    {
      no_of_days: "Last 1 Week",
      days: 7,
    },
    {
      no_of_days: "Last 1 Month",
      days: 30,
    },
    {
      no_of_days: "Last 1 Year",
      days: 365,
    },
  ];
  const insightTypes = [
    "company_insights",
    "location_insights",
    "designation_insights",
    "tenure_insights",
  ];

  const [no_of_days, setNoofDays] = useState({
    no_of_days: "Last 1 Week",
    days: 7,
  });

  const [chartData, setchartData] = useState({
    company_insights: {
      total_count: 10,
      grouped_data: {
        Google: 4,
        Amazon: 3,
        Microsoft: 2,
        Facebook: 1,
      },
    },
    location_insights: {
      total_count: 6,
      grouped_data: {
        Bangalore: 2,
        Hyderabad: 1,
        "San Francisco": 1,
        "New York": 2,
      },
    },
    designation_insights: {
      total_count: 5,
      grouped_data: {
        "Software Engineer": 2,
        "Product Manager": 1,
        "Data Analyst": 1,
        "QA Engineer": 1,
      },
    },
    tenure_insights: {
      total_count: 4,
      grouped_data: {
        "0-1 year": 1,
        "1-3 years": 2,
        "3+ years": 1,
      },
    },
  });
  const companiesAttrationInsights = () => {
    setLoading(true);
    let apiData = {
      issuer_company_id: User.company_id,
      no_of_days: no_of_days.days,
    };
    API.post(ATTRATION_INSIGHTS, apiData)
      .then((res) => {
        if (res.status == 200) {
          setLoading(false);
          setchartData(res.data.data);
        }
      })

      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };
  useEffect(() => {
    companiesAttrationInsights();
  }, [no_of_days]);

  const transformData = (groupedData) => {
    return Object.entries(groupedData).map(([name, value]) => ({
      name,
      value,
    }));
  };

  // PDF Download: render the report as HTML off-screen, capture it with
  // html2canvas, then slice the image across A4 pages in a jsPDF document.
  const downloadPDF = async () => {
    let node;
    try {
      setDownloading(true);

      node = buildInsightsReportNode({
        chartData,
        companyName: User?.user_type || User?.user_name || "Issuer",
        period: no_of_days.no_of_days,
      });
      document.body.appendChild(node);

      // Let the browser lay the node out before capturing.
      await new Promise((resolve) => requestAnimationFrame(() => resolve()));

      const pdf = new jsPDF("p", "mm", "a4");
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      const margin = 0; // report background already provides visual padding

      // Capture each top-level block on its own so a block (header, a category
      // section, footer) is never split across a page boundary. When the next
      // block won't fit in the remaining space, start a fresh page.
      const blocks = Array.from(node.querySelectorAll("[data-block]"));
      let cursorY = margin;

      // Paint the page background to match the report's light canvas.
      const paintBackground = () => {
        pdf.setFillColor(243, 244, 248); // #f3f4f8
        pdf.rect(0, 0, pageWidth, pageHeight, "F");
      };
      paintBackground();

      for (const block of blocks) {
        const canvas = await html2canvas(block, {
          backgroundColor: "#f3f4f8",
          scale: 2,
          useCORS: true,
          allowTaint: true,
        });

        const imgWidth = pageWidth - margin * 2;
        const imgHeight = (canvas.height * imgWidth) / canvas.width;
        const imgData = canvas.toDataURL("image/png");

        // If this block overflows the current page, move it to the next one.
        // (A single block taller than a full page still prints, just clipped
        // to the page — acceptable since individual blocks stay small.)
        if (cursorY + imgHeight > pageHeight - margin && cursorY > margin) {
          pdf.addPage();
          paintBackground();
          cursorY = margin;
        }

        pdf.addImage(imgData, "PNG", margin, cursorY, imgWidth, imgHeight);
        // Small gap between blocks (skipped after the last block / on new page).
        const blockGap = 3;
        cursorY += imgHeight + blockGap;
      }

      const safe = (v) => String(v || "report").replace(/[^a-zA-Z0-9]/g, "_");
      const fileName = `Attrition_Insights_${safe(
        User?.user_name
      )}_${safe(no_of_days.no_of_days)}.pdf`;
      pdf.save(fileName);
    } catch (error) {
      console.error("Error generating PDF:", error);
      alert("Error generating PDF. Please try again.");
    } finally {
      if (node && node.parentNode) node.parentNode.removeChild(node);
      setDownloading(false);
    }
  };


  const handleCharts = (e) => {
    setGraphType(e);
  };
  const handleTime = (e) => {
    setNoofDays(e);
  };
  return (
    <SlideUpWrapper direction="slide-left">


    <TopTitleBar isChild ><h2 className="topTitleBarText"><span className='secondaryButton1'>Record Insights</span></h2></TopTitleBar>

      <div
        style={{
          margin: "1rem",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div className={style.searchContainer}>
          <div style={{ display: "flex", alignItems: "center" }}>
            {No_of_Days.map((item, index) => (
              <div key={index}>
                <div
                  className={`${style.noOfDays} ${
                    no_of_days.days == item.days ? style.selected : null
                  }`}
                  onClick={() => handleTime(item)}
                >
                  {item.no_of_days}
                </div>
              </div>
            ))}
            <div
              style={{
                display: "flex",
                gap: "10px",
                alignItems: "center",
                marginLeft: "20px",
              }}
            >
              <CustomDropDown
                list={["Pie Chart", "Bar Chart", "Line Chart"]}
                selectedOption={GraphType}
                onSelect={(e) => handleCharts(e)}
              />
            </div>
          </div>
        </div>

        <div>
          {(() => {
            const disabled = loading || downloading;
            return (
              <button
                onClick={downloadPDF}
                style={{
                  padding: "8px 16px",
                  backgroundColor: disabled ? "#6c757d" : "#007bff",
                  color: "white",
                  border: "none",
                  borderRadius: "4px",
                  cursor: disabled ? "not-allowed" : "pointer",
                  fontSize: "14px",
                  display: "flex",
                  alignItems: "center",
                  gap: "5px",
                  transition: "background-color 0.2s",
                  opacity: disabled ? 0.6 : 1,
                }}
                disabled={disabled}
                onMouseOver={(e) => {
                  if (!disabled) e.target.style.backgroundColor = "#0056b3";
                }}
                onMouseOut={(e) => {
                  if (!disabled) e.target.style.backgroundColor = "#007bff";
                }}
              >
                <img
                  src="/downloadoutline.svg"
                  alt="download"
                  width="16"
                  height="16"
                />
                {downloading
                  ? "Generating..."
                  : loading
                  ? "Loading..."
                  : "Download PDF"}
              </button>
            );
          })()}
        </div>
      </div>

      <div style={{ margin: "10px" }} id="insights-charts-container">
        {loading ? (
          <ShimmerLoader />
        ) : (
          insightTypes.map((type) => {
            const chartTypeData = chartData?.[type];
            const rawData = chartTypeData?.grouped_data;

            if (!rawData) return null;

            const data = transformData(rawData ?? {});

            return (
              <div key={type} className="insight-chart-section">
                <h3>{type.replace(/_/g, " ").toUpperCase()}</h3>
                <CompanyInsightCharts data={data} Graph={GraphType} />
              </div>
            );
          })
        )}
      </div>
    </SlideUpWrapper>
  );
};

export default RecordInsights;
